import { useAuth } from '../context/AuthContext';

const useUser = () => {
  const { user, loading } = useAuth();
  return { user, loading };
};

export default useUser;
